import Vue from 'vue'
import { Store, install } from 'vuex'

import user from './module/user'
import app from './module/app'

Vue.use({ install })

export default new Store({
  modules: {
    user,
    app
  }
})
